"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var EventBus_1 = require("./EventBus");
var BusContext = react_1.default.createContext(new EventBus_1.EventBus());
exports.useBus = function () { return react_1.useContext(BusContext); };
exports.BusProvider = BusContext.Provider;
//# sourceMappingURL=BusContext.js.map